<template>
<div>
  <div v-if="waitingOnData" style="margin:10px;background-color:lightyellow">Processing Data</div>
  <div v-else-if="inError" style="margin:10px;background-color:pink">{{error_message}}</div>
  <el-table
      :data="tableData"
      style="width: 100%;margin-bottom:20px;">
    <el-table-column
        prop="long_name"
        label="Name">
      <template slot-scope="scope">
          <a :href="scope.row['definition_url']" target="_blank">{{scope.row['long_name']}}</a>
      </template>
    </el-table-column>
    <el-table-column
        prop="type"
        label="Type">
    </el-table-column>
    <el-table-column
        prop="edit_text"
        label="How to edit/define">
    </el-table-column>
  </el-table>
</div>
</template>

<script>
export default {
  name: "ListCompare",
  props: ['extent_id_from_blade'],
  data() {
    return {
      tableData: [],
      waitingOnData: false,
      inError: false,
      error_code: null,
    }
  },
  mounted() {
    axios.get('/extents/chartableTables/' + this.extent_id_from_blade).then(response => {
      this.tableData = response.data.all_tables
      this.waitingOnData = false
      this.inError = false
      console.log(response)
    }).catch(error => {
      this.waitingOnData = false
      this.inError = true
      this.error_code = error.response.status
      console.log('oops problem starting import')
      console.log(error.response)
    })
  },
  methods: {
    start(response) {
      this.inError = false
      this.waitingOnData = true

      //
    },
  },
  computed: {
    error_message: function () {
      if (this.inError) {
        if (this.error_code===504) {
          return "Timed out request, but just to see if the CSV is complete"
        } else {
          return "Error in Processing"
        }
      } else {
        return ""
      }
    },
  },
}
</script>

<style scoped>

</style>